<template>
    <div class="form">
        <!-- Traffic options -->
        <div class="form__section">
            <div class="form__title">Verkehrsinformationen</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.type" 
                        :options="typeOptions"
                        :min-amount="1"
                        :tracking-data-category="'Traffic'"
                        :output-array="true"
                        @change="fieldChangeHandler($event, 'type')"
                    />
                </div>
            </div>
        </div>

        <!-- Other filter options -->
        <div class="form__section">
            <div class="form__title">Weitere Filteroptionen</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.other" 
                        :options="otherOptions"
                        @change="fieldChangeHandler($event, 'other')"
                    />
                </div>
            </div>
        </div>

        <!-- Legend -->
        <div class="form__section">
            <div class="form__title">Legende Verkehrsfluss</div>
            <TrafficLegend />
        </div>
        

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import settingsTabBlueprint from '@/mixins/settings-tab-blueprint';
import { getPoiConfig } from '@/utils/poi-data/poi-config'
import SmrChoiceGroup from '@/components/form/SmrChoiceGroup.vue'
import TrafficLegend from '@/components/TrafficLegend'

export default {
    components: {
        SmrChoiceGroup,
        TrafficLegend,
    },
    mixins: [
        settingsTabBlueprint
    ],
    data() {
        return {
            data: {},
            typeOptions: getPoiConfig(this.optionsId).categories.filter(category => category.hideInOptions !== true),
            legend: [
                {
                    type: 'normal',
                    label: 'Freie Fahrt',
                },
                {
                    type: 'medium',
                    label: 'Zähflüssiger Verkehr',
                },
                {
                    type: 'slow',
                    label: 'Stockender Verkehr',
                },
                {
                    type: 'jam',
                    label: 'Stau',
                },
                {
                    type: 'block',
                    label: 'Sperre',
                    image: `${process.env.BASE_URL}/images/ui/blocked-route-line.svg`
                },
            ],
        }
    },
    computed: {
        ...mapGetters(['user', 'routeTrafficTime']),
        otherOptions() {
            return [
                {value: 'favouritesOnly', label: 'Nur Favoriten', disabled: this.user ? false : true },
            ]
        }
    },
    watch: {
        routeTrafficTime: {
            handler: function(newVal, oldVal) {
                if(newVal.isNow !== oldVal.isNow) this.toggleNowOptions()
            },
            deep: true
        }
    },
    mounted() {
        this.toggleNowOptions()
    },
    methods: {
        toggleNowOptions() {
            let webcamOptionIndex = this.typeOptions.findIndex(option => option.value === 'CAMERA');
            let trafficFlowIndex = this.typeOptions.findIndex(option => option.value === 'Verkehrsfluss')
            if(webcamOptionIndex >= 0) {
                this.$set(this.typeOptions[webcamOptionIndex], 'disabled', !this.routeTrafficTime.isNow)
                this.$set(this.typeOptions[webcamOptionIndex], 'tooltip', this.routeTrafficTime.isNow ? undefined : 'Nicht für Prognosen verfügbar')
            }
            if(trafficFlowIndex >= 0) {
                this.$set(this.typeOptions[trafficFlowIndex], 'disabled', !this.routeTrafficTime.isNow)
                this.$set(this.typeOptions[trafficFlowIndex], 'tooltip', this.routeTrafficTime.isNow ? undefined : 'Nicht für Prognosen verfügbar')
            }
        }
    },
}
</script>